<template>
  <div class="qrCodeBody">
    <Header />
    <div class="qrCodeMain">
      <Step :num='3' authType="1" />
      <div class="infoMainBody">
        <div class="infoArea">
          <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="170px" label-position="right">
            <el-form-item label="办理人姓名" prop="name">
              <el-input v-model="infoForm.name" :disabled="agentFlowId != ''" size="small" placeholder="请输入办理人姓名" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="办理人身份证件号" prop="identNo">
              <el-input v-model="infoForm.identNo" :disabled="agentFlowId != ''" size="small" placeholder="请输入办理人身份证件号" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item v-if="agentAuthPassed" label="办理人刷脸验证" prop="">
              <span class="agentAuthPassBox"><em class="icnColor el-icon-success"></em>办理人刷脸认证已完成</span>
            </el-form-item>
          </el-form>
          <div class="qrCode" v-if="faceMode">
            <div class="leftArea">
              <div class="codeArea">
                <img :src="'data:image/png;base64,' + img">
                <dl v-if="isScanning">
                  <dt><img src="@/assets/image/accomplish.png"></dt>
                  <dd>扫码成功</dd>
                </dl>
              </div>
              <h5><em @click="getCreateFaceUrl">刷新</em></h5>
              <h5>请使用手机微信扫一扫</h5>
              <h5>并依照提示完成人脸识别</h5>
            </div>
            <div class="demonstration">
              <img src="@/assets/image/demonstration.png">
            </div>
          </div>
        </div>
      </div>
      <div class="lineBtn">
        <!-- <el-button size="mini" v-if="agentFlowId" @click="getupdata">上一步</el-button> -->
        <el-button size="mini" @click="getRoute">上一步</el-button>
        <el-button type="primary" v-if="agentFlowId == '' || agentAuthPassed" size="mini" @click="getAgentFace">下一步 </el-button>
      </div>
    </div>
    <authResult :verifyMsg="verifyMsg" :authAgent="authAgent" :authAgentBalck="authAgentBalck" v-show="authCompletedShow" @blockAgentFace="blockFace" @blockFace="blockFace"></authResult>
  </div>
</template>

<script>
import authResult from './authResult.vue'
export default {
  data() {
    return {
      img: '',
      intervals: [],
      isScanning: false,
      faceMode: false,
      agentAuthPassed: false,
      infoForm: {
        name: '',
        mode: 2,
        identType: 0,
        identNo: null,
        smsCode: ''
      },
      countDown: 0,
      authCompletedShow: false,
      verifyMsg: '',
      face: false,
      authAgentBalck: false,
      authAgent: false,
      agentFlowId: '',
      rules: {
        identNo: [
          {
            required: true,
            message: '请输入办理人身份证件号',
            trigger: 'blur'
          },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: '请输入正确的办理人身份证号码',
            trigger: 'blur'
          }
        ],
        name: [
          { required: true, message: '请输入办理人姓名', trigger: 'blur' },
          {
            pattern: /^([\u4e00-\u9fa5]|·){2,30}$/,
            message: '请输入正确的办理人姓名',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    // this.getLegalPersonInfo()
    this.getAgentInfo()
  },
  components: {
    authResult
  },
  methods: {
    blockFace() {
      this.authCompletedShow = false
      this.isScanning = false
      this.getBackStep()
    },
    getupdata() {
      this.clearInterval()
      this.faceMode = false
      this.agentFlowId = ''
    },
    getRoute() {
      this.$router.push({ name: 'companyEntryInfo' })
    },
    getBackStep() {
      this.countDown = 0
      this.authCompletedShow = false
      this.getAgentInfo()
    },
    getAgentInfo() {
      this.$api
        .getAgentInfo({ flowId: this.$store.state.userInfo.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            this.$set(this.infoForm, 'name', res.data.agentName)
            this.$set(this.infoForm, 'identNo', res.data.agentIdentNo)
            this.agentFlowId = res.data.agentFlowId
            this.getInfo()
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          if (err.code === '6003') {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {
                this.getRoute()
              }
            })
          } else if (err.code === '1') {
            console.log(err.msg)
          } else {
            this.clearInterval()
            this.authCompletedShow = true
            this.face = true
            if (err.code === '810401' || err.code === '810403') {
              this.face = false
            }
            this.verifyMsg = err.msg
          }
        })
    },
    getInfo() {
      this.$api
        .getInfo({
          flowId: this.$store.state.userInfo.flowId
        })
        .then(res => {
          if (res.code === '0') {
            if (!res.data.agentAuthPassed) {
              this.getCreateFaceUrl()
            }
            this.agentAuthPassed = res.data.agentAuthPassed //办理人认证成功
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.$alert(err.msg, '提示', {
            confirmButtonText: '好的',
            callback: () => {}
          })
        })
    },
    getAgentFace() {
      if (this.agentAuthPassed) {
        if (this.$store.state.userInfo.authSelectMode === '4') {
          this.$router.push({ name: 'companySelectRemittanceType' })
        } else if (this.$store.state.userInfo.authSelectMode === '3') {
          this.$router.push({ name: 'companyScanningCode' })
        }
      } else {
        let data = {
          flowId: this.$store.state.userInfo.flowId,
          agentName: this.infoForm.name,
          agentIdentNo: this.infoForm.identNo
        }
        this.$refs['infoForm'].validate(valid => {
          if (valid) {
            this.$api
              .getAgentFace(data)
              .then(res => {
                if (res.code && res.code === '0') {
                  if (
                    res.data.qrCodeResponseVO &&
                    res.data.qrCodeResponseVO.fileBytes
                  ) {
                    this.faceMode = true
                    this.agentFlowId = res.data.agentFlowId
                    this.$set(
                      this,
                      'img',
                      res.data.qrCodeResponseVO &&
                        res.data.qrCodeResponseVO.fileBytes
                        ? res.data.qrCodeResponseVO.fileBytes
                        : this.img
                    )
                    this.intervals.push(
                      setInterval(() => {
                        this.getAuthPersonStatus()
                      }, 3000)
                    )
                  }
                } else {
                  return new Promise((resolve, reject) => {
                    reject(res)
                  })
                }
              })
              .catch(err => {
                if (err.code === '6003') {
                  this.$alert(err.msg, '提示', {
                    confirmButtonText: '好的',
                    callback: () => {
                      this.getRoute()
                    }
                  })
                } else {
                  this.clearInterval()
                  this.authCompletedShow = true
                  this.face = true
                  if (err.code === '810401' || err.code === '810403') {
                    this.face = false
                  }
                  this.verifyMsg = err.msg
                }
              })
          }
        })
      }
    },
    getCreateFaceUrl() {
      // this.isLoad = true
      this.clearInterval()
      this.$api
        .getPersonFace({ flowId: this.agentFlowId })
        .then(res => {
          if (res.code && res.code === '0') {
            this.img = res.data.fileBytes
            this.faceMode = true
            this.isScanning = false
            this.intervals.push(
              setInterval(() => {
                this.getAuthPersonStatus()
              }, 3000)
            )
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.clearInterval()
          this.$alert(err.msg, '提示', {
            confirmButtonText: '好的',
            callback: () => {
              this.getRoute()
            }
          })
          // this.isLoad = false
        })
    },
    getAuthPersonStatus() {
      this.authAgentBalck = false
      this.authAgent = false
      this.$api
        .checkVerifyStatus({ flowId: this.agentFlowId })
        .then(res => {
          if (res.code && res.code === '0') {
            if (res.data.status === 'DOING') {
              this.isScanning = true
            } else if (res.data.status === 'PASSED') {
              this.clearInterval()
              if (this.$store.state.userInfo.authSelectMode === '4') {
                this.$router.push({ name: 'companySelectRemittanceType' })
              } else if (this.$store.state.userInfo.authSelectMode === '3') {
                this.$router.push({ name: 'companyScanningCode' })
              }
            } else if (res.data.status === 'FAILED') {
              return new Promise((resolve, reject) => {
                reject(res)
              })
            }
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.clearInterval()
          this.authCompletedShow = true
          if (err.code === '810403') {
            //810403 办理人三次失败
            this.authAgentBalck = true
          } else {
            this.authAgent = true
          }
          this.verifyMsg = err.msg
        })
    },

    clearInterval() {
      for (let i of this.intervals) {
        clearInterval(i)
      }
    }
  },
  destroyed() {
    this.clearInterval()
  }
}
</script>

<style lang="scss" scoped>
.qrCodeBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.qrCodeMain {
  width: 1600px;
  flex: 1;
  min-height: 650px;
  margin: 16px auto 0;
  background: #fff;
  padding: 0px 0 40px;
}
.qrCode {
  width: max-content;
  margin: 64px 0 0 160px;
  display: flex;
}
.leftArea {
  text-align: center;
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
  }
  h5 {
    margin-top: 14px;
    font-size: 14px;
    color: #595959;
    line-height: 19px;
    font-weight: normal;
  }
  em {
    color: #1c67f3;
    color: var(--main-bg-color);
  }
}
.infoArea {
  width: 600px;
  margin: 51px auto 0;
  .el-input,
  .el-select {
    width: 408px;
  }
  ::v-deep.el-form-item__label {
    padding-right: 20px;
  }
  p {
    width: 408px;
    padding: 8px 12px;
    margin-top: 12px;
    background: #f1f5ff;
    border-radius: 2px;
    font-size: 12px;
    color: #595959;
    line-height: 14px;
  }
  .verificationCode {
    width: 295px;
    margin-right: 8px;
  }
  .el-button.is-plain {
    background: #fff;
    border-color: #1c67f3;
    ::v-deep span {
      color: #1c67f3;
    }
    &.codeBtn.is-disabled {
      border-color: #eceff3;
      ::v-deep span {
        color: #c0c4cc !important;
      }
    }
  }
  .verifyType {
    ::v-deep.el-radio-button__inner {
      width: 158px;
      height: 36px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d5dbe2;
      margin-right: 16px;
      &:hover {
        color: #1c67f3;
        color: var(--main-bg-color);
      }
    }
    .el-radio-button.is-active {
      ::v-deep.el-radio-button__inner {
        color: #1c67f3;
        color: var(--main-bg-color);
        border: 1px solid #1c67f3;
        border: 1px solid var(--main-bg-color);
        box-shadow: none;
      }
    }
  }
}
.codeArea {
  margin: 24px auto 0;
  width: 160px;
  height: 160px;
  position: relative;
  padding: 11px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #dee0e7;
  img {
    width: 100%;
  }
  dl {
    width: 160px;
    height: 160px;
    position: absolute;
    top: -1px;
    left: -1px;
    background: rgba($color: #fff, $alpha: 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  dt {
    width: 36px;
    margin: 0 auto;
  }
  dd {
    font-size: 16px;
    color: #333333;
    line-height: 21px;
    letter-spacing: 1px;
    margin-top: 4px;
  }
}
.demonstration {
  margin-top: 13px;
  width: 244px;
  height: 356px;
  margin-left: 65px;
  img {
    width: 100%;
  }
}
.lineBtn {
  background-color: #fff;
  width: 1600px;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #eceef1;
  padding: 12px 0;
  text-align: center;
}
.agentAuthPassBox {
  display: inline-block;
  width: 408px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  background: #f1f5ff;
  border-radius: 2px;
  padding-left: 12px;
  .icnColor {
    color: #52c41a;
    margin-right: 4px;
  }
}
</style>